<footer class="page-footer text-center">
  <div class="p-1 p-lg-3">
    <!-- CONTAINER -->
    <div class="footer-container row d-flex gap-4 gap-md-2">
      <!-- SOCIAL -->
      <div class="col-md d-flex justify-content-center align-items-center align-items-md-start gap-3">
        <img src="../../../assets/logo.png" alt="Logo Aliwell" class="align-center logo">
        <div class="d-flex gap-3 align-center">
          <div class="social-icon">
            <a href="https://www.facebook.com/aliwell.smiles" target="_blank">
              <i class="fa fa-facebook-official"></i>
            </a>
          </div>
          <div class="social-icon">
            <a href="https://www.instagram.com/aliwell.smiles" target="_blank">
              <i class="fa fa-instagram"></i>
            </a>
          </div>
          <div class="social-icon">
            <a href="https://www.youtube.com/@aliwell.smiles" target="_blank">
              <i class="fa fa-youtube-play"></i>
            </a>
          </div>
          <div class="social-icon">
            <a href="https://www.linkedin.com/company/aliwell" target="_blank">
              <i class="fa fa-linkedin-square"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- CONTACT -->
      <div class="contact-grid col-md-6">
        <div class="contact-item d-flex" *ngFor="let contactItem of contactData">
          <i class="{{contactItem.iconClass}} fs-lg me-2"></i>
          <p class="mb-0 text-start">{{ contactItem.content }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Copyright -->
  <div class="copyright d-flex flex-row justify-content-center align-items-center gap-6 text-center p-2 m-0 fw-light fs-md">
    <p class="text-end text-white">Aliwell<sup>&#174;</sup> {{todayDate | date:'YYYY' }}</p>
    <p class="text-start text-white">
      <a class="text-reset" [href]="privacyNoticeUrl" target="_blank" rel="noopener noreferrer">Avisos de privacidad</a>
    </p>
  </div>
</footer>
